import { render, staticRenderFns } from "./centerOrderTableDetail.vue?vue&type=template&id=0aebf42a&scoped=true&"
import script from "./centerOrderTableDetail.vue?vue&type=script&lang=js&"
export * from "./centerOrderTableDetail.vue?vue&type=script&lang=js&"
import style0 from "./centerOrderTableDetail.vue?vue&type=style&index=0&id=0aebf42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aebf42a",
  null
  
)

export default component.exports